<template>
  <div class="page-content">
    <div class="title">
      Google Ads settings
      <br />
      Production
      <br />
      https://nkr-admin-bucket.s3.us-east-2.amazonaws.com/processed-files/google_ads.csv
      <br />
      Dev
      <br />
      https://nkr-admin-bucket-dev.s3.us-east-2.amazonaws.com/processed-files/google_ads.csv
    </div>
    <div class="list" v-if="!loading">
      <div class="box">
        <template v-if="!procedureLast || procedureLast.dateFinished != null">
          <a class="btn-dark-button" @click="excecuteProcedure()"
            >Generate Google Ads now</a
          >
          <template v-if="procedureLast">
            <p>
              Excecuted last time on: {{ procedureLast.dateFinished }} by
              {{ procedureLast.user }}
            </p>
            <template v-if="procedureLast.success == '1'">
              <p class="success">
                Last process was successfull
              </p>
            </template>
            <template v-else>
              <p class="error">
                Last process fail
              </p>
            </template>
          </template>
        </template>
        <template v-else>
          <BaseSmallSpinner />
          Recreate in progress...
          <template>
            <br />
            <br />
            Is this proccess taking too long?
            <a v-if="!cancelling" @click="cancelProcess()">cancel now</a>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getProcedures,
  requestCancelProcess
} from "@/api/store/ProcedureService.js";
import { generateGoogleAds } from "@/api/store/GoogleAdsService.js";
const PROCEDURE_NAME = "google_ads_site_generation";
const CURRENT_PROCEDURE = "google_ads";
export default {
  data() {
    return {
      procedures: [],
      loading: true,
      interval: null,
      skipRefresh: false,
      cancelling: false
    };
  },
  computed: {
    procedureLast() {
      if (this.procedures.length == 0) {
        clearInterval(this.interval);
        return null;
      } else {
        const recreate = this.procedures.filter(x => {
          return x.procedureName == PROCEDURE_NAME;
        });
        if (recreate[0].dateFinished) {
          clearInterval(this.interval);
        }
        return recreate[0];
      }
    }
  },
  mounted() {
    this.getProcedureLogs();
    this.interval = setInterval(() => {
      if (!this.skipRefresh) {
        this.getProcedureLogs();
      }
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    async getProcedureLogs() {
      this.procedures = await getProcedures(CURRENT_PROCEDURE);
      this.loading = false;
      if (this.procedureLast.dateFinished) {
        this.cancelling = false;
      }
    },
    async excecuteProcedure() {
      generateGoogleAds();
      this.procedures.unshift({
        procedureName: PROCEDURE_NAME,
        dateFinished: null
      });
      this.interval = setInterval(() => {
        this.getProcedureLogs();
      }, 5000);
    },
    cancelProcess() {
      this.cancelling = true;
      requestCancelProcess(CURRENT_PROCEDURE, PROCEDURE_NAME);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/App.scss";
.list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  .box {
    margin: 10px;
    width: 350px;
    padding: 20px;
    @extend .shadow-4dp;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    text-align: center;
    position: relative;
    flex-direction: column;
    .options {
      display: none;
    }
    a {
      color: red;
    }
    &:hover {
      .options {
        display: block;
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        flex-direction: row;
        .icon {
          border: 1px solid $M8;
          border-radius: 10px;
          padding: 5px;
          width: 30px;
          margin-left: 5px;
          &:hover {
            background-color: $M8;
          }
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
